import { useEffect, useState } from 'react';

/** The current instant in milliseconds, refreshed every `intervalMs` (default 30 s): a countdown must move on its own, not only when the data is re-read. */
export function useNow(intervalMs = 30_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
